import React from 'react'
import { StyledLink, StyledHashLink, StyledNavDropdown } from './styled'
import { Nav, NavDropdown } from 'react-bootstrap'
import { NavListItem, NavList } from './../../components'

const NavigationBar = ({isCurrentLocation}) => {

    const paths = {
        institucional: '/institucional',
        filosofia: '/filosofia',
        segmentos: '/segmentos',
        obras: '/obras',
        clientes: '/clientes',
        noticias: '/noticias',
        contato: '/contato'
    }

    return (
        <Nav className='w-100'>
            <NavList>
                <NavListItem>
                    <StyledLink
                        to={paths.institucional}
                        isCurrentLocation={isCurrentLocation(paths.institucional)}
                    >
                        Institucional
                    </StyledLink>
                </NavListItem>

                <NavListItem>
                    <StyledLink 
                        to={paths.filosofia}
                        isCurrentLocation={isCurrentLocation(paths.filosofia)}
                    >
                        Filosofia
                    </StyledLink>
                </NavListItem>

                <NavListItem>
                    <StyledLink
                        to={paths.segmentos}
                        isCurrentLocation={isCurrentLocation(paths.segmentos)}
                    >
                        Segmentos
                    </StyledLink>
                </NavListItem>

                {/* <NavListItem> */}
                <StyledNavDropdown title="Obras" isCurrentLocation={isCurrentLocation(paths.obras)}>
                    <NavDropdown.Item>
                    <StyledHashLink to={'/obras#recem-entregues'}>
                        Recém-entregues
                    </StyledHashLink>
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                        <StyledHashLink to={'/obras#execucao'}>
                            Em execução
                        </StyledHashLink>
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                        <StyledHashLink to={'/obras#portfolio'}>
                            Portfólio
                        </StyledHashLink>
                    </NavDropdown.Item>
                </StyledNavDropdown>
                    {/* <StyledLink
                        to={paths.obras}
                        isCurrentLocation={isCurrentLocation(paths.obras)}
                    >
                        Obras
                    </StyledLink> */}
                {/* </NavListItem> */}

                <NavListItem>
                    <StyledLink
                        to={paths.clientes}
                        isCurrentLocation={isCurrentLocation(paths.clientes)}
                    >
                        Clientes
                    </StyledLink>
                </NavListItem>

                <NavListItem>
                    <StyledLink
                        to={paths.noticias}
                        isCurrentLocation={isCurrentLocation(paths.noticias)}
                    >
                        Notícias
                    </StyledLink>
                </NavListItem>

                <NavListItem>
                    <StyledLink
                        to={paths.contato}
                        isCurrentLocation={isCurrentLocation(paths.contato)}
                    >
                        Contato
                    </StyledLink>
                </NavListItem>
            </NavList>
        </Nav>
    )
}

export default NavigationBar